// 是否为空
export const isEmpty = val => val === null || val === undefined

// 字符串是否为空
export const isStringEmpty = val => isEmpty(val) || val.trim().length === 0

// 节流函数
export function throttle (fn, delay = 1500) {
  let isRun = true
  return function (...args) {
    if (!isRun) {
      return
    }
    fn.apply(this, args)
    isRun = false
    setTimeout(() => {
      isRun = true
    }, delay)
  }
}

export function debounce (func, delay = 200) {
  let timer = null
  return function () {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, arguments)
    }, delay)
  }
}

// 数字至少显示n位
export function numFormat (num, n = 2) {
  const numStr = num.toString()
  if (numStr.length >= n) {
    return numStr
  }
  //   位数差
  const diff = n - numStr.length
  let zeroStr = ''
  for (let i = 0; i < diff; i++) {
    zeroStr += '0'
  }

  return zeroStr + numStr
}

// 生成n位数字字母组合字符串id
export function createId (n = 8) {
  let id = ''
  for (let i = 0; i < n; i++) {
    const random = Math.floor(Math.random() * 36)
    id += random.toString(36)
  }
  return id + Date.now()
}



// WEBPACK FOOTER //
// ./src/utils/index.js